import { gql } from '@apollo/client'
import { DISPLAY_SHELF_FRAGMENT } from './DisplayShelfFragment'

export const DISPLAY_SEGMENT_FRAGMENT = gql`
  fragment DisplaySegment on DisplaySegment {
    segmentNumber
    shelves {
      ...DisplayShelf
    }
  }
  ${DISPLAY_SHELF_FRAGMENT}
`
